export default __webpack_public_path__ + "static/media/noun_Happy_50025.fb1d3481.png";